<template>
  <header
    :style="{
      backgroundImage: isHomeLike
        ? 'url(' + require('../assets/images/header/banner.jpg') + ')'
        : 'url(' + require('../assets/images/header/banner-normal.png') + ')',
    }"
  >
    <img
      :style="{ display: 'block', width: '100%' }"
      src="../assets/images/header/上方帘子.png"
      alt=""
    />

    <a href="https://azurlane.yo-star.com/" target="_blank">
      <img
        :style="{
          position: 'absolute',
          left: '1rem',
          top: '0.4rem',
          width: '3.6rem',
        }"
        src="../assets/images/header/logo.png"
        alt=""
      />
    </a>

    <div class="button-wrap" v-if="!hideButton">
      <!-- <div class="button-name" :class="{ active: NICK_NAME }" @click="login"> -->
      <!-- {{ NICK_NAME ? NICK_NAME : "Log In" }} -->
      <!-- </div> -->
      <div class="works-filter" :class="{ logged: NICK_NAME }">
        <div class="works-search">
          <!-- <div class="iconfont-search" @click="searchList">
          <i class="iconfont iconicon-chaxun"></i>
        </div> -->
          <div class="works-search-box">
            <input
              type="text"
              @keydown.enter="searchList"
              placeholder="Search"
              v-model="searchContent"
              class="works-search-input"
            />
          </div>
          <div class="search-icon" @click="searchList"></div>
        </div>
      </div>
      <div class="button-login" v-show="!NICK_NAME" @click="login"></div>
      <div class="login-suc" v-show="NICK_NAME">{{ NICK_NAME }}</div>

      <div class="button-out" v-show="NICK_NAME" @click="logout"></div>
      <div class="button-rules" @click="rulesOpen"></div>
      <div class="button-submit" @click="toUpload"></div>
    </div>

    <img
      v-if="isHomeLike"
      :style="{
        position: 'absolute',
        width: '100%',
        left: '0%',
        top: '53%',
        zIndex: 3,
        pointerEvents: 'none',
      }"
      src="../assets/images/home/蝴蝶结.png"
      alt=""
    />
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '../plugins/bus'
export default {
  name: 'Header',
  components: {},
  data: () => ({
    hideButton: false,
    searchContent: '',
  }),
  created() {
    this.hideButton = this.$route.meta.hideButton
  },
  mounted() {},
  watch: {
    searchContent(val) {
      EventBus.$emit('searchValueChange', val)
    },
    $route(to, from) {
      this.searchContent = ''
    },
  },
  computed: {
    ...mapState({
      NICK_NAME: state => state.User.NICK_NAME,
      ART_SUBMIT_ENABLE: state => state.Config.ART_SUBMIT_ENABLE,
      COS_SUBMIT_ENABLE: state => state.Config.COS_SUBMIT_ENABLE,
      LCOS_SUBMIT_ENABLE: state => state.Config.LCOS_SUBMIT_ENABLE,
    }),
    isHomeLike() {
      return this.$route.name !== 'upload' && this.$route.name !== 'watch'
    },
  },
  methods: {
    logout() {
      this.$store
        .dispatch('User/logout')
        .then(v => {
          this.$router.replace({ path: '/' }).catch(() => {})
        })
        .catch(e => {
          console.log(e)
        })
    },
    searchList() {
      window.gtag('event', 'click_search')
      EventBus.$emit('searchKeyDown')
    },
    login() {
      window.gtag('event', 'click_login')
      this.$store.commit('LoginMask/SET_MASK_ACTIVE', true)
    },
    toUpload() {
      window.gtag('event', 'click_submit')
      if (this.ART_SUBMIT_ENABLE || this.COS_SUBMIT_ENABLE || this.LCOS_SUBMIT_ENABLE) {
        this.$store
          .dispatch('User/getUserInfo')
          .then(v => {
            const route = this.$router.resolve({ path: 'upload' })

            window.open(route.href, '_blank')
          })
          .catch(e => {
            // 获取用户信息
            console.log(e)
          })
      } else {
        alert('The event has ended. Please continue to follow the subsequent process.')
      }
    },
    rulesOpen() {
      window.gtag('event', 'click_rules')
      this.$store.commit('Home/SET_RULES_POPUP_STATE', true)
    },
  },
}
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  height: 0;
  padding-bottom: 40%;
  background: url(../assets/images/header/banner.jpg) no-repeat;
  background-size: 100%;
  position: relative;
  .button-wrap {
    position: absolute;
    top: pxTorem(18px);
    right: pxTorem(15px);
    display: flex;
    align-items: center;
    .works-filter {
      position: relative;
      margin-right: pxTorem(238px);
      border-radius: pxTorem(24px);
      box-sizing: border-box;
      width: pxTorem(374px);
      line-height: pxTorem(46px);
      box-sizing: border-box;
      display: flex;
      background: url(../assets/images/header/search-bg.png) no-repeat;
      background-size: contain;
      background-position: center;
      aspect-ratio: 380/55;
      transition: 0.3s;

      &:hover {
        background-image: url(../assets/images/header/search-hover.png);

        .search-icon {
          background-image: url(../assets/images/header/search-act.png) !important;
        }
      }
      .works-search {
        width: 100%;
        font-size: 0;
        display: flex;
        box-sizing: border-box;
        .works-search-box {
          flex: 1;
          order: 0;
          .works-search-input {
            display: block;
            outline: pxTorem(2px) solid #ffffff;
            width: 83%;
            height: 100%;
            @include clearInput;
            padding: 0 pxTorem(24px);
            color: black;
            font-size: pxTorem(18px);
          }
        }
        .search-icon {
          cursor: pointer;
          position: absolute;
          right: 0.1rem;
          top: 0.05rem;
          z-index: 2;
          width: pxTorem(47px);
          height: pxTorem(47px);
          background-image: url(../assets/images/header/search.png);
          background-size: 100% 100%;
          transition: 0.3s;
        }
      }
    }
    .logged {
      margin-right: pxTorem(34px);
    }
    .button-name {
      height: pxTorem(45px);
      width: pxTorem(150px);
      position: absolute;
      right: pxTorem(180px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      background: url(../assets/images/header/name.png);
      background-size: 100% 100%;
      font-family: 'Noto Sans KR', sans-serif;
      cursor: pointer;
      text-align: center;
      font-weight: bold;
      color: white;
      font-size: pxTorem(19px);
      line-height: pxTorem(60px);
      &.active {
        background: url(../assets/images/header/nameActive.png);
        background-size: 100% 100%;
      }
    }
    .button-login {
      cursor: pointer;
      width: pxTorem(41px);
      height: pxTorem(53px);
      background-image: url(../assets/images/header/login.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      margin-right: pxTorem(34px);
      background-repeat: no-repeat;
      background-position: center;
      &:hover {
        background-image: url(../assets/images/header/login-act.png);
      }
    }
    .login-suc {
      margin-right: pxTorem(21px);
      white-space: nowrap; /* 确保文本在一行内显示 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 使用打点省略 */
      max-width: pxTorem(189px);
      height: pxTorem(36px);
      font-weight: 800;
      font-size: pxTorem(24px);
      color: #fffffe;
      line-height: pxTorem(36px);
    }
    .button-out {
      cursor: pointer;
      width: pxTorem(57px);
      height: pxTorem(53px);
      background-image: url(../assets/images/header/logout.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      margin-right: pxTorem(29px);
      &:hover {
        background-image: url(../assets/images/header/logout-act.png);
      }
    }
    .button-submit {
      cursor: pointer;
      width: pxTorem(150px);
      height: pxTorem(45px);
      background-image: url(../assets/images/header/sub.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      &:hover {
        background-image: url(../assets/images/header/sub-act.png);
      }
    }

    .button-rules {
      cursor: pointer;
      width: pxTorem(59px);
      height: pxTorem(53px);
      margin-right: pxTorem(27px);
      background-image: url(../assets/images/header/rule.png);
      background-size: 100% 100%;
      transition: all 0.3s;
      &:hover {
        background-image: url(../assets/images/header/rule-act.png);
      }
    }
  }
}
</style>
